var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"flix-glyphicon",class:_vm.get_class()})
}
var staticRenderFns = []

export { render, staticRenderFns }